<div class="mat-elevation-z8 buttonDiv">
  <div class="filter-actions-line">
    @if(controlPermissions.addButton){
      <button mat-raised-button color="primary" (click)="openMarketForm(true)"
          data-testId="btnAddMarket">
        <mat-icon>add</mat-icon>
        <span>Add Market</span>
      </button>
    }
    <div class="custom-search-box">
      <mat-icon>search</mat-icon>
      <input matInput [value]="filterText" (keyup)="applyFilter($event)" placeholder="Filter Markets..." data-testId="btnSearch" />
    </div>
  </div>
</div>
<div class="market-container mat-elevation-z8 mar-top-20">
  <div class="mat-mdc-card gridheight clear-both viewport">
    <table mat-table [dataSource]="dataSource" class="mat-table" multiTemplateDataRows matSort>
      <ng-container matColumnDef="expandIcon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell
            *matCellDef="let element"
            style="width: 32px; border-right: 1px solid currentColor; padding-right: 24px; text-align: center;"></td>
      </ng-container>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
          Actions
        </th>
        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
      </ng-container>
       <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="mat-header-row actionwidth">
            Actions
          </th>
          <td mat-cell *matCellDef="let row">
            <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="openContextmenu(row, 'EDIT')">
              <mat-icon>edit</mat-icon>
            </button>
            @if(controlPermissions.delete){             
              <button mat-icon-button type="button" color="warn" title="Delete" (click)="openContextmenu(row, 'DELETE')" style="color: red;">
                <mat-icon>delete</mat-icon>
              </button>
            }
        </td>
      </ng-container>
      <ng-container matColumnDef="regionName">
        <th mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="mat-header-row">
          Market
        </th>
        <td mat-cell *matCellDef="let element">{{ element.regionName }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell"
            [attr.colspan]="displayedColumns.length"
            style="color: red; text-align: center; font-weight: 500">
          No data matching the filter.
        </td>
      </tr>
    </table>
  </div>
</div>
